import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Home from '../pages/Home';
import Federal from '../pages/Federal';
import Commercial from '../pages/Commercial';
import ContactForm from '../components/ContactForm';
import PageTransition from './PageTransition';

const AnimatedRoutes: React.FC = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location}>
        <Route
          path="/"
          element={
            <PageTransition>
              <Home />
            </PageTransition>
          }
        />
        <Route
          path="/federal"
          element={
            <PageTransition>
              <Federal />
            </PageTransition>
          }
        />
        <Route
          path="/commercial"
          element={
            <PageTransition>
              <Commercial />
            </PageTransition>
          }
        />
        <Route
          path="/contact"
          element={
            <PageTransition>
              <ContactForm />
            </PageTransition>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes; 